import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import { VuejsDatatableFactory } from 'vuejs-datatable'
import App from './App.vue'
// import './registerServiceWorker'
import router from './router'
import store from './store'
import _ from 'lodash'
import HighchartsVue from 'highcharts-vue'
import Raphael from 'raphael/raphael'
import VueScrollProgressBar from '@guillaumebriday/vue-scroll-progress-bar'

import 'vue-multiselect/dist/vue-multiselect.min.css'
import Multiselect from 'vue-multiselect'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
Vue.use(Toast);
Vue.component('VueMultiselect', Multiselect)
global.Raphael = Raphael

const components = require.context('./components/sofbox')
_.forEach(components.keys(), (fileName) => {
  const componentConfig = components(fileName)
  const componentName = fileName.split('/').pop().split('.')[0]
  Vue.component(componentName, componentConfig.default || componentConfig)
})

Vue.filter('reverse', function (value) {
  // slice to make a copy of array, then reverse the copy
  return value.slice().reverse()
})
Vue.use(HighchartsVue)

Vue.use(VueScrollProgressBar)

Vue.config.productionTip = false

Vue.use(VuejsDatatableFactory)

let vm = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

window.vm = vm

// let baseUrl = process.env.VUE_APP_BASEURL
